import { ReadingProgress, ReadingProgressCreate } from "../types";
import api from "./api";

export const readingProgressService = {
  async create(progress: ReadingProgressCreate): Promise<ReadingProgress> {
    const response = await api.post<ReadingProgress>("/reading-progress", progress);
    return response.data;
  },
};
